<template>
  <v-app>
    <Navbar v-if="showNav" />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Navbar from '@/components/UI/Navbar.vue';

const store = useStore();
const route = useRoute();

const user = computed(() => store.state.auth.providerLoginInfos);
const showNav = computed(() => route.name && route.name !== 'Login');
</script>

<style lang="scss">
@import './styles/app.scss';
</style>
